import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FrequencyCap = ({
  height = 24,
  width = 24,
  color = colors.grey50,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <g
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
      strokeOpacity={0}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8.625 8.25C8.42609 8.25 8.23532 8.32902 8.09467 8.46967C7.95402 8.61032 7.875 8.80109 7.875 9V15C7.875 15.1989 7.95402 15.3897 8.09467 15.5303C8.23532 15.671 8.42609 15.75 8.625 15.75C8.82391 15.75 9.01468 15.671 9.15533 15.5303C9.29598 15.3897 9.375 15.1989 9.375 15V9C9.375 8.80109 9.29598 8.61032 9.15533 8.46967C9.01468 8.32902 8.82391 8.25 8.625 8.25ZM7.03401 7.40901C7.45597 6.98705 8.02826 6.75 8.625 6.75C9.22174 6.75 9.79403 6.98705 10.216 7.40901C10.6379 7.83097 10.875 8.40326 10.875 9V15C10.875 15.5967 10.6379 16.169 10.216 16.591C9.79403 17.0129 9.22174 17.25 8.625 17.25C8.02826 17.25 7.45597 17.0129 7.03401 16.591C6.61205 16.169 6.375 15.5967 6.375 15V9C6.375 8.40326 6.61205 7.83097 7.03401 7.40901Z" />
      <path d="M10.875 12.0008C10.875 11.5865 11.2108 11.2508 11.625 11.2508H20.625C21.0392 11.2508 21.375 11.5865 21.375 12.0008C21.375 12.415 21.0392 12.7508 20.625 12.7508H11.625C11.2108 12.7508 10.875 12.415 10.875 12.0008Z" />
      <path d="M2.625 12.0008C2.625 11.5865 2.96079 11.2508 3.375 11.2508H5.625C6.03921 11.2508 6.375 11.5865 6.375 12.0008C6.375 12.415 6.03921 12.7508 5.625 12.7508H3.375C2.96079 12.7508 2.625 12.415 2.625 12.0008Z" />
    </g>
  </SvgIcon>
);
